import { Component, Input, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Subscription } from "../subscription.model";
import { I18NextService } from "angular-i18next";
import { Model } from 'src/app/app.model';
import { SaleOrder } from 'src/app/buy/buy.model';

@Component({
    selector: 'app-subscription-availability-card',
    templateUrl: './subscription-availability-card.component.html',
    standalone: false
})
export class AvailabilityCardComponent implements OnInit {

    @Input()
    public subscription: Subscription;


    constructor(private router: Router,
        private m: Model, private i18next: I18NextService) {
    }
    
    public deliveryDate: string;
    public isOrderAvailability = false;

    public ngOnInit() {
        const order = this.availabilityOrder;
        if (order) {
            this.isOrderAvailability = true;
            this.deliveryDate = order.deliveryDate;
        }
    }

    public changeAvailability() {
        if (this.isOrderAvailability) return;
        this.router.navigate(['/do', ...this.roleSegment, 'availability', this.subscription.appliance_id]);
    }

    public cancelOrder() {
        this.router.navigate(['/do', ...this.roleSegment, 'availability', this.subscription.appliance_id, 'order-cancel']);
    }

    private get roleSegment() {
        if (!this.subscription.is_my) {
            const user = this.m.account.currentUser;
            if (user.companyIsPC20Csp) return ['csp'];
            else if (user.companyIsPartner) return ['partner'];
        }

        return [];
    }

    public get currentAvailibilty() {
        return this.i18next.t(`availability_${(this.subscription.availability ?? 'standard').toLowerCase()}`);
    }

    public get nextAvailibility() {
        let prod = 'premium';
        if (this.availabilityOrder.lines.find(line => line.product === 'PC-ONE-CANCEL-PREMIUM')) {
            prod = 'standard';
        }

        return this.i18next.t(`availability_${prod}`);
    }

    private get availabilityOrder(): SaleOrder {
        return this.subscription.orders.find(order =>
            order.lines.find(line =>
                ['PC-ONE-PREMIUM', 'PC-ONE-CANCEL-PREMIUM'].includes(line.product)
            )
        );
    }
}
